import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Observer } from 'gsap/Observer';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

gsap.registerPlugin(ScrollTrigger, Observer, MotionPathPlugin);

// Expose npm GSAP (with plugins) as window.gsap so MouseFollower uses same instance
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
